import { Component, ViewChild, ElementRef, SimpleChanges, Input, HostListener } from '@angular/core';

@Component({
  selector: 'say-horizontal-slider',
  templateUrl: './horizontal-slider.component.html',
  styleUrls: ['./horizontal-slider.component.scss']
})
/**A plain JS solution to slide from one inline container to one of its sibling containers */
export class HorizontalSliderComponent {

  /**Reference to the largest container divider in this component  */
  @ViewChild('container', { static: true }) container: ElementRef;
  /**The new state to slide to */
  @Input() newState: number;

  /**The current/previous state of the slider*/
  public currState: number = 0;
  /**An array containing the states in the component, IE. The containers children */
  public states: Array<number> = [];

  constructor() { }

  /**
   * If the state changes, slide or fade the new state
   *  - Largest state accepted is length of children.
   * @param changes The changes that the were made to the component
   */
  ngOnChanges(changes: SimpleChanges): void {
    this.newState = Math.min(this.newState, this.container.nativeElement.children.length);

    this.slide(this.newState);

    this.currState = this.newState;
  }

  /**
   * Slides the viewable state to the specified child element
   *  - "Slide" one state over
   *  - "Fade" more than one state over
   *  - Change nothing if states match
   * @param child the zero-based index of the child to slide into view
   */
  public slide(child: number): void {
    if (Math.abs(this.newState - this.currState) == 1) {
      this.horizontalScroll(this.container.nativeElement, child, 150);
    } else if (Math.abs(this.newState - this.currState) > 1) {
      this.horizontalScroll(this.container.nativeElement, child, 10);
    }
  }

  /**Scrolls the element horizontally
   * @param element the element to scroll
   * @param state the designated state to scroll to
   * @param duration the length of time until the element arrives
   */
  public horizontalScroll(element: HTMLElement, state: number, duration: number) {
    element.style.transition = `transform ${duration}ms ease`;
    element.style.transform = `translateX(-${state * 100}%)`;
  }
}
